module.exports = __webpack_public_path__ + "media/src/images/icons/test/primary-fe711ddafe545968cc5af061b8ff72b3.svg";